/**
 * Enable preloading of links using either the native Speculation Rules API
 * or the 'quicklink' library as a fallback.
 */
async function enableLinkPreloading() {
  // Ignore when logged in as links with side effects could be inadvertently triggered
  if (document.getElementById('wpadminbar')) return

  // Browser itself reports lack of Speculation API support
  if (HTMLScriptElement.supports('speculationrules')) {
    // Safari fallback: assume lack of support because Safari reports `true` for
    // `HTMLScriptElement.supports('speculationrules')` even if speculation rules are not
    // available (which they usually are in Safari as they need to be manually enabled)
    if (navigator.userAgent.includes('Safari/') && !navigator.userAgent.includes('Version/')) return
  }

  // Keep quicklink as fallback until the Speculation Rules API is widely supported
  // https://github.com/GoogleChromeLabs/quicklink
  const { listen } = await import('quicklink')

  // This matches mimics the behavior of the native speculation rules we provide in WordPress
  console.debug('Enable quicklink library')

  const currentUrlObject = new URL(window.location.href)

  listen({
    ignores: [
      (url, element) => {
        const urlObject = new URL(url)

        // Ignore /wp-* links
        if (urlObject.pathname.startsWith('/wp-')) return true

        // Ignore links with query strings
        if (urlObject.search.length > 0) return true

        // Ignore links to the current page
        if (urlObject.pathname === currentUrlObject.pathname) return true

        // Ignore nofollow links
        if (element.matches('a[rel~="nofollow"]')) return true

        // Ignore .no-prefetch links
        if (element.matches('.no-prefetch, .no-prefetch *')) return true

        return false
      },
    ],
  })
}

if (window.wpceElementScriptsLoaded) {
  enableLinkPreloading().catch(error => console.error(error))
} else {
  document.addEventListener(
    'wpce:after-element-scripts',
    async () => {
      await enableLinkPreloading()
    },
    { once: true },
  )
}
